/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { CardWithID } from '@mythos/game/Rules';
import { BasicCardRenderer } from './CardView';
import PileView from './PileView';
import { MEDIA_QUERY_MOBILE } from './mobile_ui/MStyles';

export function CardSelectorView(props: {
  title: string;
  cards: CardWithID[];
  onSelectCard: (card: CardWithID) => void;
  renderer?: (props: {
    card: CardWithID;
    ref?: React.Ref<HTMLDivElement>;
  }) => React.ReactElement;
}) {
  return (
    <div css={SelectorView.container}>
      <div css={SelectorView.title}>{props.title}</div>
      <PileView
        cards={props.cards}
        renderer={props.renderer ?? BasicCardRenderer}
        hoverRenderer={BasicCardRenderer}
        onCardClick={(c) => props.onSelectCard(c)}
      />
    </div>
  );
}

const SelectorView = {
  container: css({
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 1,
    [MEDIA_QUERY_MOBILE]: {
      width: '60vw',
    },
  }),
  title: css({
    fontSize: '24px',
    marginBottom: '12px',
    alignSelf: 'center',
  }),
};
